import { EntityType } from "@mapmycustomers/shared";
import { FilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import CalendarViewMode from "@app/enum/CalendarViewMode";
import { ActivityFieldName } from "@app/util/fieldModel/ActivityFieldModel";
import { getSimpleConditionForField } from "@app/util/filters/utils";
import { parseApiDate } from "@app/util/parsers";

import getActivityDateRange from "./getActivityDateRange";

// The window a calendar or scheduler request covers; none when its filter has no start date.
const getPlannerRequestRange = (
  filter: FilterModel,
  viewMode: CalendarViewMode
): [Date, Date] | undefined => {
  const startAt = getSimpleConditionForField(
    filter,
    ActivityFieldName.START_AT,
    EntityType.ACTIVITY
  )?.value;
  return startAt ? getActivityDateRange(parseApiDate(startAt), viewMode) : undefined;
};

export default getPlannerRequestRange;
